
import WorkQGeneralWidget from "./WorkQGeneralWidget"
import classes from '../DashboardItem.module.css'
import { dashboardFunctions } from "../../../../lib/dashboard"
import WorkQWidgetsWrapperMultiple from "./WorkQWidgetsWrapperMultiple"

export default function WorkQWidgetsWrapper() {
    // let workqs = retrieveAllWorkQs()?.filter(item => !item.type).slice(0, 8)

    let userWorkqs = dashboardFunctions.getUserWorkQs()



    return <div >
        {userWorkqs && userWorkqs.type == 'single' && userWorkqs.workqs && userWorkqs.workqs.length > 0 && <div className={`${classes.workq_widgets_wrapper}`}>
            {userWorkqs.workqs.map(item => (
                <WorkQGeneralWidget key={item.slug} workq={item} />
            ))}    
        </div>}
        {userWorkqs && userWorkqs.type == 'multiple' && userWorkqs.workqs && userWorkqs.workqs.length > 0 && <div className={`${classes.workq_widgets_wrapper_multiple}`}>
            <WorkQWidgetsWrapperMultiple userWorkqs={userWorkqs} classes={classes}/>
            
        </div>}
    </div>
}